import Image from 'next/legacy/image';
import { useTranslation } from '@yoweb/next-i18next';
import { TextualStepLayout } from './Common';
import { jsx as _jsx } from "react/jsx-runtime";
export var SkippedConfirmationStep = function SkippedConfirmationStep(_ref) {
  var taskFeedback = _ref.taskFeedback,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(TextualStepLayout, {
    title: t('todo-feedback.skipped-confirmation-title'),
    description: t('todo-feedback.skipped-confirmation-description'),
    bannerImage: /*#__PURE__*/_jsx(Image, {
      src: "/images/illustrations/wellness-tasks.svg",
      width: 198,
      height: 218
    }),
    taskFeedback: taskFeedback,
    onClose: onClose,
    "data-testid": "skipped-confirmation-step"
  });
};